import { defineComponent as _defineComponent } from 'vue'
import { computed, ref } from "vue";
  import DropDown from "@/components/ui/dropdown/DropDown.vue";
  import RemoveDocumentsModal from "@/components/ui/modals/RemoveDocumentModal.vue";
  import ImagePreviewModal from "@/components/ui/modals/ImagePeviewModal.vue";
  import router from "@/router";
  import store from "@/store";
  import { formatDate } from "@/helpers/date";
  import { DocumentTypeEnum } from "@/enums/DocumentTypeEnum";
  import { useToast } from "vue-toastification";
  import {
    isValidFileSize,
    isValidDocumentType,
    validDocumentsTypes,
  } from "@/helpers/fileUpload";
  import { getDocumentName, isImage } from "@/helpers/documents";
  import { downloadFile as downloadDocument } from "@/helpers/downloadFile";
  import DocumentItem from "@/components/ui/DocumentItem.vue";
  import { isLotOwner } from "@/helpers/lot/isLotOwner";
  import { LotInterface } from "@/types/LotInterface";
  import { Business } from "@/types/BusinessInterface";
  import { AxiosResponse } from "axios";

  
export default /*@__PURE__*/_defineComponent({
  __name: 'LotDocuments',
  props: {
    tab: {
      type: String,
      default() {
        return DocumentTypeEnum.DOCUMENTS;
      },
    },
    lot: {
      type: Object,
    },
    isAdmin: {
      type: Boolean,
    },
    inner: {
      type: Boolean,
      default: false,
    },
  },
  emits: ["addDocument", "deleteDocument"],
  setup(__props, { expose: __expose, emit: __emit }) {
  __expose();

  const toast = useToast();
  const props = __props;
  const emit = __emit;
  const showImg = ref<any>(null);
  const lotId = router.currentRoute.value.params.lotId;
  const docs = computed(() => {
    if (props.tab === DocumentTypeEnum.CONTRACTS) {
      return props.lot ? props.lot.contracts : [];
    }

    return props.lot ? props.lot.documents : [];
  });
  const estateId = computed(() => {
    return store.state.user.selectedEstateId;
  });
  const fileInput = ref(null);
  const fileForDelete = ref({ file: "", index: 0 });
  const isOpenRemoveDocumentsModal = ref(false);
  const documentTypes = validDocumentsTypes.join(", ");
  const loading = ref(false);
  const loadingUserBusiness = ref(true);
  const isContactsPage = computed(() => {
    return router.currentRoute.value.name === "ContactDetails";
  });
  const isLotContractsTab = computed(() => {
    return router.currentRoute.value.name === "LotContracts";
  });
  const userBusiness = ref<Business | null>(null);
  const estate = computed(() =>
    store.state.user.landownerEstates.find((e) => e._id === estateId.value)
  );
  const canManageLot = computed(() => {
    if (loadingUserBusiness.value) return false;

    return isLotOwner(
      props.lot as LotInterface,
      userBusiness.value,
      estate.value
    );
  });

  const getUserBusiness = () => {
    loadingUserBusiness.value = true;
    store
      .dispatch("business/getBusinessByLandownerId")
      .then((res: AxiosResponse<Business>) => {
        userBusiness.value = res.data;
      })
      .catch(() => {
        toast.error("Failed to load user permissions");
      })
      .finally(() => {
        loadingUserBusiness.value = false;
      });
  };

  getUserBusiness();

  const uploadDocument = (e: any) => {
    if (!canManageLot.value) {
      toast.error("You don't have permission to add documents to this lot");
      return;
    }

    if (!e.target.files.length) {
      return;
    }

    const file = e.target.files[0];

    fileInput.value.value = "";

    if (!isValidDocumentType(file) || !isValidFileSize(file)) {
      return;
    }

    loading.value = true;
    const data = new FormData();

    data.append("file", file);
    data.append("documentType", props.tab);
    data.append("lotId", lotId as string);
    data.append("estateId", estateId.value);
    store
      .dispatch("lot/uploadLotDocuments", data)
      .then((res) => {
        toast.success("Your document was successfully uploaded");
        emit("addDocument", { file: res.data, documentType: props.tab });
      })
      .catch(() => toast.error("Something went wrong"))
      .finally(() => (loading.value = false));
  };

  function openDocument(doc: { fileName: string; link: string }) {
    if (isImage(doc.fileName)) {
      showImg.value = doc.link;
    } else {
      window.open(doc.link, "_blank");
    }
  }
  const deleteDocument = () => {
    loading.value = true;
    store
      .dispatch("lot/deleteLotDocument", {
        lotId: lotId,
        fileName: fileForDelete.value.file,
        documentType: props.tab,
      })
      .then(() => {
        emit("deleteDocument", {
          index: fileForDelete.value.index,
          documentType: props.tab,
        });
      })
      .catch(() => toast.error("Something went wrong"))
      .finally(() => (loading.value = false));
    isOpenRemoveDocumentsModal.value = false;
  };

  function downloadFile(filename: string, link = "") {
    if (link) {
      downloadDocument(link);
      return;
    }

    store
      .dispatch("lot/downloadLotDocument", {
        id: lotId,
        filename,
        documentType: props.tab,
      })
      .then((res) => {
        window.open(res.data, "_blank");
      });
  }
  function showDeleteFileModal(file: string, index: number) {
    fileForDelete.value = { file, index };
    isOpenRemoveDocumentsModal.value = true;
  }

const __returned__ = { toast, props, emit, showImg, lotId, docs, estateId, fileInput, fileForDelete, isOpenRemoveDocumentsModal, documentTypes, loading, loadingUserBusiness, isContactsPage, isLotContractsTab, userBusiness, estate, canManageLot, getUserBusiness, uploadDocument, openDocument, deleteDocument, downloadFile, showDeleteFileModal, computed, ref, DropDown, RemoveDocumentsModal, ImagePreviewModal, get router() { return router }, get store() { return store }, get formatDate() { return formatDate }, get DocumentTypeEnum() { return DocumentTypeEnum }, get useToast() { return useToast }, get isValidFileSize() { return isValidFileSize }, get isValidDocumentType() { return isValidDocumentType }, get validDocumentsTypes() { return validDocumentsTypes }, get getDocumentName() { return getDocumentName }, get isImage() { return isImage }, get downloadDocument() { return downloadDocument }, DocumentItem, get isLotOwner() { return isLotOwner }, get LotInterface() { return LotInterface }, get Business() { return Business }, get AxiosResponse() { return AxiosResponse } }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})